import { DriveItemListOrigin } from '../containers/DriveItemListPage/constants';

export const pathHashbang = '(!/)';

export enum RoutePath {
	Default = '(!/)',
	Home = '(!/)home',
	ViewDriveItem = '(!/)view/:driveItemId(/:page)',
	Authentication = '(!/)authentication',
	ParametersPage = '(!/)parameters',
	ProfilePage = '(!/)profile',
	DriveItemListPage = '(!/)list/:origin(/:originParam)',
	TheaterList = '(!/)list/:origin(/:originParam)/theater/:driveItemId',
	Theater = '(!/)theater/:driveItemId',
	SharePage = '(!/)share/:driveItemId(/:page)',
	DriveItemDetailPage = '(!/)detail(/:folderId)/:driveItemId',
	NotFound = '*',
	StaticPage = '(!/)page/:component',
	Editor = '(!/)editor/:clientId/:resourceId',
	ProposalStatsPage = '(!/)proposal_stats',
	NotesPage = '(!/)notes',
}

export interface RouteParamsDriveItemListPage {
	origin: DriveItemListOrigin;
	originParam: string;
}

export interface RouteParamsTheater extends RouteParamsDriveItemListPage {
	driveItemId: string;
}

export interface RouteParamsDriveItemDetailPage {
	driveItemId: string;
}

export interface RouteParamsStaticPage {
	component: string;
}

export interface RouteParamsEditor {
	clientId: number;
	resourceId: number;
}

export type RouteParams = RouteParamsDriveItemListPage | RouteParamsTheater | RouteParamsDriveItemDetailPage | RouteParamsStaticPage | RouteParamsEditor | {};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes/constants.ts